import { Capacitor, CapacitorHttp } from '@capacitor/core'
import { LiveUpdate } from '@capawesome/capacitor-live-update'
import { App } from '@capacitor/app'

const BUNDLE_URL = 'https://api.housejet.com/app-updates'

const checkForUpdate = async () => {
  if (!Capacitor.isNativePlatform() || process.env.NODE_ENV === 'development') {
    return
  }
  try {
    const currentBundle = await LiveUpdate.getCurrentBundle()
    const response = await CapacitorHttp.get({ url: `${BUNDLE_URL}/manifest.json` })

    if (response.status !== 200) {
      return
    }

    const manifest = response.data
    const latestVersion = manifest.version
    const bundleUrl = manifest.url
    
    if (currentBundle.bundleId === latestVersion) return

    const bundles = await LiveUpdate.getDownloadedBundles()
    if (bundles.bundleIds.includes(latestVersion)) {
      await LiveUpdate.setNextBundle({ bundleId: latestVersion })
      await LiveUpdate.reload()
      return
    }

    await LiveUpdate.downloadBundle({
      bundleId: latestVersion,
      url: bundleUrl
    })

    await LiveUpdate.setNextBundle({ bundleId: latestVersion })
    await LiveUpdate.reload()
  } catch (error) {
    // Reset to built-in bundle to prevent loading from a broken state
    try {
      await LiveUpdate.reset()
    } catch (e) {
      console.error('[LiveUpdate] Error resetting to built-in bundle:', e)
      // Silent fail
    }
    console.error('[LiveUpdate] Error:', error)
  }
}

export default async function initLiveUpdate () {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  try {
    await LiveUpdate.ready()
    console.log('[LiveUpdate] Ready')
  } catch (e) {
    // Silent fail
  }

  setTimeout(() => {
    checkForUpdate()
  }, 3000)

  App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      checkForUpdate()
    }
  })
}
